<template>
  <div class="row">
    <div class="col-md-12" style="background: white">
      <table class="table table-striped">
        <thead>
          <tr>
            <th colspan="3"></th>
            <th></th>
            <th></th>
            <th colspan="3">
              <router-link :to="{ name: 'client.ovenreport.create' }">
                <div class="btn btn-info" style="float: right">
                  <i class="fa fa-plus"></i> Add Oven Report
                </div>
              </router-link>
            </th>
          </tr>
          <tr>
            <th style="width: 2%">SN</th>
            <th style="width: 8%" scope="col">Date</th>
            <th style="width: 10%" scope="col">Shift</th>
            <th style="width: 15%" scope="col">Oven Supervisor</th>
            <th style="width: 15%" scope="col">Shift Incharge</th>
            <th style="width: 20%" scope="col">Action</th>
          </tr>
        </thead>
        <tbody v-if="!getLoadingData && filteredPromoCodes.length > 0">
          <tr v-for="(item, index) in filteredPromoCodes" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.date }}</td>
            <td>{{ item.shift }}</td>
            <td>{{ item.oven_supervisor }}</td>
            <td>{{ item.shift_incharge }}</td>
            <td>
              <button
                @click="editData(item.id)"
                class="btn btn-warning btn-sm mr-3"
              >
                Edit
              </button>
              <button
                @click="ViewItem(item.id, index)"
                class="btn btn-info btn-sm"
              >
                View
              </button>
              <button
                @click="deleteItem(item.id)"
                class="btn btn-sm btn-danger ml-2"
                style="cursor: pointer"
              >
                Delete
              </button>
            </td>
          </tr>
        </tbody>

        <tbody v-if="!getLoadingData && filteredPromoCodes.length < 1">
          <tr>
            <td colspan="10" class="text-center">No record(s) found</td>
          </tr>
        </tbody>

        <tbody v-if="getLoadingData">
          <tr>
            <th class="text-center" colspan="10">
              <vDataLoader></vDataLoader>
            </th>
          </tr>
        </tbody>
        <!----><!---->
      </table>
      <hr v-if="pagination.total_page > 1" />
      <vl-pagination
        v-on:selected="selectedPage"
        v-on:previous="previousPage"
        v-on:first="firstPage"
        v-on:last="lastPage"
        v-on:next="nextPage"
        v-if="pagination.total_page > 1"
        :pagination="pagination"
      ></vl-pagination>
    </div>
    <ovenReportDetailModal
      :key="key"
      v-if="ovenReportDetailModalShow"
      v-on:closemodal="closeModal"
      :loading-data="loadingData"
      :has-data="hasData"
      :show-modal="ovenReportDetailModalShow"
      :oven-report-detail="ovenReportDetail"
      :index-num="currentIndex"
    ></ovenReportDetailModal>
  </div>
</template>

<script>
import moment from "moment";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import {
  FETCH_DAILY_OVEN_REPORTS,
  FETCH_SELF_OVEN_REPORT,
  DELETE_DAILY_OVEN_REPORT,
} from "@/core/services/store/actions.type";
import { mapGetters } from "vuex";
import vDataLoader from "@/components/frontend/spinner.vue";
import vlPagination from "@/includes/table/Pagination";
import ovenReportDetailModal from "@/components/frontend/modal/ovenreportdetail";
export default {
  data() {
    return {
      pagination: {
        total_records: 0,
        total_page: 0,
        current_page: 1,
        per_page_data: 15,
        received_per_page_data: 15,
      },
      key: 0,
      ovenReportDetailModalShow: false,
      filteredPromoCodes: [],
      ovenReportDetail: {},
      breadCrumbs: [
        {
          id: 1,
          title: "Dashboard",
          route: "client.dashboard",
        },
        {
          id: 2,
          title: "Oven Reports",
          route: "",
        },
      ],
      loadingData: false,
      getLoadingData: false,
      hasData: false,
      searchInput: "",
    };
  },
  components: {
    vDataLoader,
    ovenReportDetailModal,
    vlPagination,
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.getPromocodesData();
  },
  filters: {
    convertDateFormat(value) {
      return moment(value).format("MM/DD/YYYY");
    },
  },
  methods: {
    selectedPage(n) {
      this.pagination.current_page = n;
      this.getPromocodesData();
    },
    nextPage() {
      this.pagination.current_page = this.pagination.current_page + 1;
      this.getPromocodesData();
    },
    lastPage() {
      this.pagination.current_page = this.pagination.total_page;
      this.getPromocodesData();
    },
    firstPage() {
      this.pagination.current_page = 1;
      this.getPromocodesData();
    },
    previousPage() {
      this.pagination.current_page = this.pagination.current_page - 1;
      this.getPromocodesData();
    },
    closeModal() {
      this.ovenReportDetailModalShow = false;
    },
    editData(id) {
      this.$router.push({ name: "client.ovenreport.edit", params: { id: id } });
    },
    ViewItem(appId, index) {
      this.currentIndex = index;
      this.ovenReportDetailModalShow = true;
      this.selectedAppId = appId;
      this.loadingData = true;
      this.$store
        .dispatch(FETCH_SELF_OVEN_REPORT, appId)
        .then((res) => {
          this.ovenReportDetail = res.data;
          this.loadingData = false;
          this.hasData = true;
          this.key += 1;
        })
        .catch(() => {
          this.loadingData = false;
        });
    },
    getPromocodesData() {
      this.getLoadingData = true;
      var page = this.pagination.current_page;
      this.$store
        .dispatch(FETCH_DAILY_OVEN_REPORTS, page)
        .then((data) => {
          this.filteredPromoCodes = data.data;
          this.pagination.total_records = data.total_record;
          this.pagination.total_page = data.page_range;
          this.pagination.received_per_page_data = data.data.length;
          this.pagination.per_page_data = 15;
          this.getLoadingData = false;
        })
        .catch(() => {
          this.getLoadingData = false;
        });
    },
    deleteItem(id) {
      this.$swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover!",
        buttons: true,
        dangerMode: true,
        showCancelButton: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((willDelete) => {
        if (willDelete.isConfirmed) {
          this.$store
            .dispatch(DELETE_DAILY_OVEN_REPORT, id)
            .then(() => {
              this.$toastr.s("Deleted Successfully");
              this.getPromocodesData();
            })
            .catch((err) => {
              this.errors = err;
            });
        }
      });
    },
  },
};
</script>

<style></style>
